module.exports = __webpack_public_path__ + "static/img/jcb.a10f40b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/present/jcb.png
// module id = 5B2M
// module chunks = 0